import React from 'react';


export const LangContext = React.createContext({
  lang: 'fr',
  prefix: 'content/',
});
export default LangContext;
